var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tendency >= 0)?_c('img',{attrs:{"src":require("../assets/images/thumb-up.jpg"),"alt":_vm.$t('averageDeviation.alt.up'),"width":"30","height":"30"}}):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21a1c54a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AverageDeviation.vue
// module id = null
// module chunks = 